const removeKey = (target, path) =>
  Object.keys(target).reduce((acc, key) => {
    if (key !== path) {
      return Object.assign({}, acc, { [key]: target[key] })
    }

    return acc
  }, {})

export default removeKey



// WEBPACK FOOTER //
// ./helpers/removeKey.js